class BD_Realtime {
	constructor() {

	}

	init(options) {

	}
}

const realtime = new BD_Realtime();
